/**
 * ============================================================
 *  趣宠会官网 · 届次/标题/日程/资源 集中配置
 *  ----------------------------------------------------------
 *  换届或更名时，只需修改本文件，并重新构建部署。
 *  严禁在其他源码文件中再次硬编码届次、年份、标题、日期。
 *  （本文件使用 CommonJS 导出，以便 vue.config.js 直接 require）
 * ============================================================
 */
module.exports = {
    // ---------- 届次写法 ----------
    // 全站默认中文写法：用于首页标题 / 售票页等
    editionZh: '第五届',
    // 赞助页 Sponsor.vue 保留的历史写法（「第5届」，勿与 editionZh 统一）
    editionNum: '第5届',

    // ---------- 品牌词 ----------
    brandName: '趣宠会',
    expoName: '天津国际AI+宠物产业博览会',

    // ---------- 各类标题（换届只改这里） ----------
    // 首页标题 = 「第五届趣宠会——暨天津国际AI+宠物产业博览会」
    homeTitle: '第五届趣宠会——暨天津国际AI+宠物产业博览会',
    // 内页统一品牌词（供「页面名 | 品牌词」拼接）
    siteTitle: '趣宠会——天津国际AI+宠物产业博览会',
    // 赞助服务页整行标题（保留「第5届」「暨」写法，换届请同步改届次）
    sponsorTitle: '第5届趣宠会暨天津国际AI+宠物产业博览会广告服务及赞助办法',

    // ---------- SEO 描述 ----------
    homeDesc: '第五届趣宠会——暨天津国际AI+宠物产业博览会官方网站。趣宠会聚焦宠物产业，汇聚宠物食品、用品、医疗服务、活体等品类，提供展会介绍、展商服务、观众服务、展会公告与行业资讯。',
    defaultDesc: '趣宠会（天津国际AI+宠物产业博览会）官方网站，提供展会介绍、展商服务、观众服务、展会公告与行业资讯。',
    keywords: '趣宠会,天津宠物展,天津宠博会,天津宠物,天津狗狗,天津猫咪,天津趣宠',

    // ---------- 活动日程（换届改日期） ----------
    schedule: {
        show: '2026年10月16日-18日',    // 展会时间
        build: '2026年10月14日-15日',   // 布展时间
        teardown: '2026年10月18日',      // 撤展时间
    },

    // ---------- 对外资源 ----------
    download: {
        // 参展申请表（public/down 下，已去除年份命名，换届上传新表覆盖即可）
        applicationFormUrl: '/down/参展申请表.pdf',
    },

    // ---------- 静态资源备忘（换届换图，同名覆盖即可，代码无需改动） ----------
    // 门票凭证长图（SpecialCode.vue 使用，位于 src/assets/images/login/）
    //   文件：detail00-2026-02.jpg —— 换届如出新版图，请以同名覆盖该文件后重新构建
    assetNotes: 'detail00-2026-02.jpg (门票凭证图, src/assets/images/login/)',
}
